export default {
    'name': '74',
    'width': '64',
    'height': '64',
    'viewBox': '0 0 64 64',
    'data': '<path fill-rule=\'evenodd\' clip-rule=\'evenodd\' d=\'M7 0V60H11V64H57V4H48.4L44.4 0H7ZM53 8.60001L50.4 6H55V62H13V60H53V8.60001ZM9 58H51V10H43V2H9V58ZM45 3.39999L49.6 8H45V3.39999ZM47 16H13V18H47V16ZM13 20H47V22H13V20ZM47 24H13V26H47V24ZM13 28H27V30H13V28ZM15 39H13V54H15V39ZM17 44H19V54H17V44ZM23 35H21V54H23V35ZM25 41H27V54H25V41ZM31 37H29V54H31V37ZM33 43H35V54H33V43ZM39 41H37V54H39V41ZM41 34H43V54H41V34ZM47 37H45V54H47V37ZM13 14H39V6H13V14ZM37 12H15V8H37V12Z\' fill=\'#026958\'/>'
}
